import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { MessagesModule } from '@shared/modules/messages';
import { provideNgxMask } from 'ngx-mask';

import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import {
  cachingInterceptorProviders,
  ENVIRONMENTS,
  initializeI18n,
  languageInterceptorProviders,
  routeHistoryProviders,
} from '@shared/core';
import { LocalizationModule, LocalizationService } from '@shared/modules/localization';
import { kk_KZ, NZ_I18N, ru_RU } from 'ng-zorro-antd/i18n';
import { provideQuillConfig } from 'ngx-quill';
import { environment } from '../environments/environment';
import { APP_ROUTES } from './app.routes';
import { authInterceptorProviders } from './core';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ENVIRONMENTS,
      useValue: environment,
    },
    { provide: LOCALE_ID, useValue: 'ru' },
    {
      provide: NZ_I18N,
      useFactory: () => {
        const localId = inject(LOCALE_ID);
        switch (localId) {
          case 'ru':
            return ru_RU;
          case 'kk':
          default:
            return kk_KZ;
        }
      },
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    cachingInterceptorProviders,
    authInterceptorProviders,
    routeHistoryProviders,
    languageInterceptorProviders,
    provideNgxMask(),
    importProvidersFrom(LocalizationModule.forRoot()),
    importProvidersFrom(MessagesModule.forRoot()),
    provideRouter(APP_ROUTES),
    provideAppInitializer(() => {
      const localizationService = inject(LocalizationService);
      return initializeI18n(localizationService)();
    }),
    provideQuillConfig({}),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
  ],
};
